export default "__VITE_ASSET__CxIiD0lx__"